import { useSelector } from 'react-redux';
import { getBaseUrl, getFullUrl, getPath } from '../redux/router';

export const useRouter = () => {
  const pathname = useSelector(getPath);
  const fullUrl = useSelector(getFullUrl);
  const baseUrl = useSelector(getBaseUrl);

  return {
    pathname,
    fullUrl,
    baseUrl,
  };
};
